export default class Enum {
    name
    value

    constructor(key, value) {
        this.name = key;
        this.value = value;
    }

    static cases() {
        return []
    }

    static tryFrom(value) {
        const myEnum = this.cases().filter(k => k.value === value);
        if(myEnum.length === 0) {
            return null;
        }
        return myEnum[0];
    }

    static from(value) {
        const myEnum = this.tryFrom(value);
        if(myEnum === null) {
            throw new Error('illegal enum value');
        }
        return myEnum;
    }
}
